// @tsignore
module.exports = require("./lib/v1alpha2");
